import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { addUserRequest, addUserSuccess, addUserFailure } from '../reducers/addUser';
import { toggleAddUserPopupSuccess } from '../reducers/view';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api`;

function* addUserFunctionAxios() {
  const state = yield select(fullState => fullState);
  const {
    user: { userId },
    token,
  } = state.loginReducer;
  const email = state.form.addUserForm.values.Email;

  const response = yield call(() =>
    axios({
      method: 'post',
      url: `${API}/user/${userId}/invite`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
      credentials: 'same-origin',
      data: {
        userId,
        email,
      },
    }),
  );
  return response;
}

function* workerAddUserSaga() {
  try {
    const response = yield call(addUserFunctionAxios);
    const responseFromAddUser = response.data;
    if (response.status === 200) {
      yield put(addUserSuccess(responseFromAddUser));
      yield put(toggleAddUserPopupSuccess(true));
    }
    if (response.status === 201) {
      yield put(addUserFailure(responseFromAddUser.message));
    }
  } catch (error) {
    yield put(addUserFailure(error.message));
  }
}

export function* watcherAddUserSaga() {
  yield takeLatest(addUserRequest().type, workerAddUserSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/post_addUser.js